module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "padded"
  }, [(!_vm.hidePanel) ? _c('edit-pane', {
    ref: "cd",
    attrs: {
      "title": _vm.form.name,
      "is-edit": _vm.editMode,
      "prefix": _vm.prefix,
      "show-edit-button": _vm.isAdding || _vm.profile().login === _vm.form.login || _vm.isSuper(),
      "show-background": !_vm.isAdding
    },
    on: {
      "save": _vm.onSave,
      "cancel": _vm.onCancel,
      "edit": _vm.onEdit,
      "add": _vm.onAdd
    }
  }) : _vm._e(), _vm._v(" "), _c('el-form', {
    ref: "contactDetailsForm",
    attrs: {
      "label-width": "90px"
    }
  }, [_c('el-tabs', {
    attrs: {
      "type": "border-card"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Contact"
    }
  }, [_c('el-row', [_c('el-form-item', {
    attrs: {
      "label": "Name",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": _vm.disabled,
      "placeholder": "Full Name"
    },
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", $$v)
      },
      expression: "form.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Short Name"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": _vm.disabled,
      "placeholder": "Short Name"
    },
    model: {
      value: (_vm.form.shortName),
      callback: function($$v) {
        _vm.$set(_vm.form, "shortName", $$v)
      },
      expression: "form.shortName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Job Title"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.form.jobTitle),
      callback: function($$v) {
        _vm.$set(_vm.form, "jobTitle", $$v)
      },
      expression: "form.jobTitle"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-form-item', {
    attrs: {
      "label": "Phone"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "phone",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.form.phone),
      callback: function($$v) {
        _vm.$set(_vm.form, "phone", $$v)
      },
      expression: "form.phone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "E-mail"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "email",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.form.email),
      callback: function($$v) {
        _vm.$set(_vm.form, "email", $$v)
      },
      expression: "form.email"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('check-box', {
    attrs: {
      "label": "Upload Alerts",
      "disabled": _vm.disabled && _vm.isManager()
    },
    model: {
      value: (_vm.form.sendUploadAlerts),
      callback: function($$v) {
        _vm.$set(_vm.form, "sendUploadAlerts", $$v)
      },
      expression: "form.sendUploadAlerts"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('check-box', {
    attrs: {
      "label": "Approval Alerts",
      "disabled": _vm.disabled && _vm.isManager()
    },
    model: {
      value: (_vm.form.sendApprovalAlerts),
      callback: function($$v) {
        _vm.$set(_vm.form, "sendApprovalAlerts", $$v)
      },
      expression: "form.sendApprovalAlerts"
    }
  })], 1)], 1), _vm._v(" "), _c('password-dialog', {
    staticClass: "text-right",
    attrs: {
      "change": "",
      "new-psw": _vm.isAdding,
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.form),
      callback: function($$v) {
        _vm.form = $$v
      },
      expression: "form"
    }
  })], 1), _vm._v(" "), (_vm.isSuper() && _vm.isTowerCo()) ? _c('el-tab-pane', {
    attrs: {
      "label": "System Details"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('el-form', {
    attrs: {
      "label-position": "top",
      "inline": true
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('switch-input', {
    attrs: {
      "label": "Enabled?",
      "on-text": "Enabled",
      "off-text": "Disabled",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.form.enabled),
      callback: function($$v) {
        _vm.$set(_vm.form, "enabled", $$v)
      },
      expression: "form.enabled"
    }
  }), _vm._v(" "), _c('text-input', {
    attrs: {
      "label": "Login ID",
      "placeholder": "Login Id",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.form.login),
      callback: function($$v) {
        _vm.$set(_vm.form, "login", $$v)
      },
      expression: "form.login"
    }
  })], 1)], 1), _vm._v(" "), (_vm.form.orgCategory === 'Tower Company') ? _c('section', [_c('el-row', {
    attrs: {
      "gutter": 5.28
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('select-input', {
    attrs: {
      "list": _vm.roles,
      "label": "Default View",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.form.defaultView),
      callback: function($$v) {
        _vm.$set(_vm.form, "defaultView", $$v)
      },
      expression: "form.defaultView"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [(!_vm.disabled) ? _c('el-transfer', {
    attrs: {
      "titles": ['All Roles', 'User Roles'],
      "data": _vm.roles
    },
    on: {
      "change": _vm.changeUserRoles
    },
    model: {
      value: (_vm.userRoles),
      callback: function($$v) {
        _vm.userRoles = $$v
      },
      expression: "userRoles"
    }
  }) : _c('el-form-item', {
    attrs: {
      "label": "User Roles"
    }
  }, _vm._l((_vm.roles), function(role, i) {
    return _c('span', {
      key: i
    }, [(_vm.userRoles.includes(role.value)) ? _c('el-tag', {
      attrs: {
        "type": role.type
      }
    }, [_vm._v("\n                        " + _vm._s(role.label) + "\n                      ")]) : _vm._e(), _vm._v(" \n                    ")], 1)
  }), 0)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 5.28
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 6
    }
  }, [_c('switch-input', {
    attrs: {
      "label": "View Only",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.form.viewer),
      callback: function($$v) {
        _vm.$set(_vm.form, "viewer", $$v)
      },
      expression: "form.viewer"
    }
  }), _vm._v(" "), _c('el-alert', {
    attrs: {
      "title": "View Only",
      "type": "info",
      "description": "View Only can't add, edit or delete anything. Only can create tickets.",
      "show-icon": "",
      "closable": false
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 6
    }
  }, [_c('switch-input', {
    attrs: {
      "label": "Approver",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.form.approver),
      callback: function($$v) {
        _vm.$set(_vm.form, "approver", $$v)
      },
      expression: "form.approver"
    }
  }), _vm._v(" "), _c('el-alert', {
    attrs: {
      "title": "Requests Module Only",
      "type": "success",
      "description": "Approver for Requests (can approve and send approval email)",
      "show-icon": "",
      "closable": false
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 6
    }
  }, [_c('switch-input', {
    attrs: {
      "label": "Manager",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.form.manager),
      callback: function($$v) {
        _vm.$set(_vm.form, "manager", $$v)
      },
      expression: "form.manager"
    }
  }), _vm._v(" "), _c('el-alert', {
    attrs: {
      "title": "Manager",
      "type": "warning",
      "description": "Manager can add, edit and delete according to role(s)",
      "show-icon": "",
      "closable": false
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 6
    }
  }, [_c('switch-input', {
    attrs: {
      "label": "Super",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.form.super),
      callback: function($$v) {
        _vm.$set(_vm.form, "super", $$v)
      },
      expression: "form.super"
    }
  }), _vm._v(" "), _c('el-alert', {
    attrs: {
      "title": "Super User",
      "type": "error",
      "description": "Super User can create users and delete anything even sites.",
      "show-icon": "",
      "closable": false
    }
  })], 1)], 1)], 1) : _vm._e()], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isManager() || _vm.isSuper()) ? _c('el-tab-pane', {
    attrs: {
      "label": "Remarks"
    }
  }, [_c('html-input', {
    attrs: {
      "label": "Remarks",
      "show-empty-message": true,
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.form.remarks),
      callback: function($$v) {
        _vm.$set(_vm.form, "remarks", $$v)
      },
      expression: "form.remarks"
    }
  })], 1) : _vm._e()], 1)], 1), _vm._v(" "), (!_vm.isAdding) ? _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("ID "), _c('b', [_vm._v(_vm._s(_vm.form.organisation_id + '-' + _vm.form.id + '-' + _vm.form.created_at))])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5c75eb0f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tables/details/ContactDetail.vue
// module id = 1516
// module chunks = 0